import { BillingPlanMetric } from '../metrics/BillingPlanMetric';

export class ConsolidatedMiuConsumption extends BillingPlanMetric {
  constructor(consolidatedMiuConsumption: Partial<ConsolidatedMiuConsumption | null>, billingMetrics: string) {
    super(consolidatedMiuConsumption);
    this.metric.metricId = billingMetrics;
    Object.assign(this, consolidatedMiuConsumption);
  }
}
